<parkour-button class="w-full" iconAfter="login" (click)="onLoginClick()">
  {{ 'buttons.aanmelden' | translate }}
</parkour-button>
